import React from "react";

import { useTheme } from "../../../../context/theme";
import { Box, Column, Columns } from "../../../layout";
import { Text } from "../../../typography";

type Props = {
  removeable?: boolean;
  dataNoTranslate?: boolean;
  onClickRemove: () => void;
  children: React.ReactNode;
};

export default function MultiValueLabel({
  removeable,
  onClickRemove,
  dataNoTranslate,
  children
}: Props) {
  const theme = useTheme();

  return (
    <Box
      onClick={e => e.stopPropagation()}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      height="fit-content"
      paddingX="xlarge"
      paddingY="small"
      borderRadius="small"
      backgroundColor={theme["primary-medium-surface"]}
      whiteSpace="nowrap"
    >
      <Columns space="large" alignY="center">
        <Column width="2/3" alignX="flex-start">
          <Text
            dataNoTranslate={dataNoTranslate || undefined}
            size="small"
            weight="bold"
            tone="primary"
          >
            {children}
          </Text>
        </Column>
        <Column width="1/3" alignX="flex-start">
          {removeable && (
            <Box alignItems="center" onClick={onClickRemove}>
              <Text size="small" tone="primary">
                &#x2715;
              </Text>
            </Box>
          )}
        </Column>
      </Columns>
    </Box>
  );
}
